import React, { forwardRef } from 'react';
import { Input } from "../..";
import { IconSearch } from "../../../icons";
import { EventKeys } from "../../../utils";
import { jsx as ___EmotionJSX } from "@emotion/core";
var DropdownSelectSearchField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var query = _ref.query,
      onChange = _ref.onChange,
      setHighlightedIndex = _ref.setHighlightedIndex,
      ulRef = _ref.ulRef,
      triggerRef = _ref.triggerRef,
      ariaLabel = _ref.ariaLabel,
      placeholder = _ref.placeholder;

  var handleSearchChange = function handleSearchChange(event) {
    if (event && event.target) {
      onChange(event.target.value);
    }
  };

  var handleSearchKeyDown = function handleSearchKeyDown(event) {
    if (event.key === EventKeys.ARROW_DOWN && setHighlightedIndex && ulRef.current) {
      event.preventDefault(); // update UI by focusing and internal downshift state to consistently navigate with arrow keys

      setHighlightedIndex(0);
      ulRef.current.focus();
    } // When tabbing away from the search field


    if (event.key === EventKeys.TAB || event.key === EventKeys.ESCAPE) {
      event.preventDefault();

      if (triggerRef && triggerRef.current) {
        triggerRef.current.click();
      }
    }
  };

  return ___EmotionJSX(Input, {
    ref: ref,
    width: "100%",
    value: query,
    placeholder: placeholder,
    onChange: handleSearchChange,
    insetElementLeading: {
      element: ___EmotionJSX(IconSearch, {
        "aria-hidden": true,
        color: "primary70"
      })
    },
    "aria-label": ariaLabel,
    onKeyDown: handleSearchKeyDown
  });
});
export default DropdownSelectSearchField;